<template>
  <div class="container">
    <div class="follow">
      <div>扫码关注公众号并收藏产品方便下次购买！</div>
      <img :src="followUrl" />
    </div>
    <div class="continue" @click="continueBuy">继续购买</div>
  </div>
</template>
<script>
const NAME = "followHint";
import { follow } from "@api/public";

export default {
  name: NAME,
  components: {},
  data: function() {
    return {
      followUrl: ""
    };
  },
  watch: {},
  mounted: function() {
    let { id } = this.$route.params;
    console.log(id);
    follow().then(res => {
      console.log(res);
      this.followUrl = res.data.path;
    });
  },
  methods: {
    continueBuy() {
      this.$router.push({ path: "/order/submit/" + this.$route.params.id });
    }
  }
};
</script>

<style scoped>
.container {
  padding-top: 2rem;
  background-color: #fff;
  min-height: 100%;
}
.follow {
  width: 3rem;
  margin: auto;
}
.follow img {
  width: 3rem;
  height: 4rem;
  border-radius: 10px;
}
.continue {
  width: 3rem;
  padding: 0.3rem 0.5rem;
  border-radius: 1rem;
  border: solid 1px black;
  margin: auto;
  box-sizing: border-box;
  text-align: center;
}
</style>
